import styled from '@emotion/styled'
import { MdErrorOutline } from 'react-icons/md'
import { Col } from 'react-bootstrap'

export const styledAlertIcon = styled(MdErrorOutline)`
  label: styledAlertIcon;
  color: ${(props) => props.theme.colors.primaryButtonHover};
  height: 1.4em;
  width: 1.4em;
  position: absolute;
  left: 8px;
  top: 28px;
`

export const EmissionContainer = styled('div')`
  label: emissionContainer;
  padding-bottom: 30px;
`

export const SubMenuContainer = styled('div')`
  label: SubMenuContainer;
  position: sticky;
  top: 0;
  z-index: 10;
`

export const CardText = styled(Col)`
  label: CardText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
`

export const CardValue = styled(Col)`
  label: CardValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: ${(props) => (props.leftValue ? 'left' : 'right')};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
`

export const CardHeader = styled.div`
  label: CardHeader;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 900)};
  text-transform: uppercase;
`

export const CardHeaderValue = styled.div`
  label: CardHeaderValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: 700;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '24px' : '18px')};
`

export const GreyTextDiv = styled.div`
  label: GreyTextDiv;
  color: ${(props) => props.theme.colors.grey2};
  margin-left: 15px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  font-size: ${(props) => (props.smallerText ? '16px' : '18px')};
`

export const BrandDefaultText = styled.div`
  label: BrandDefaultText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const StyledH3 = styled.h3`
  label: StyledH3;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 800)};
  font-size: 24px;
`

export const SubHeadingDiv = styled.div`
  label: SubHeadingDiv;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-transform: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'uppercase' : 'none'};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 900)};
`
